export const DarknetConstants = {
  MinCyclesToProcess: 1,
  MaxCyclesToProcess: 3,
  DataFileSuffix: ".data.txt",
  /** Discounted price when buying in Shadowed Walkway */
  DarkscapeNavigatorDiscountedPrice: 30e6,
  /** Standard price when buying via darkweb */
  DarkscapeNavigatorPrice: 50e6,
} as const;

export const MAX_PASSWORD_LENGTH = 50;
